import React, { useState } from 'react';
import { Input } from '../common/Input';
import { Button } from '../common/Button';
import { authService } from '../../services/authService';
import toast from 'react-hot-toast';

type AddStudentFormProps = {
  onStudentAdded: () => void;
};

export const AddStudentForm = ({ onStudentAdded }: AddStudentFormProps) => {
  const [password, setPassword] = useState('');
  const [login, setLogin] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);

    // POPRAWKA: Wywołanie z 4 argumentami, bez `email`
    const promise = authService.createUser(login, password, firstName, lastName);
    
    toast.promise(promise, {
        loading: 'Dodawanie kursanta...',
        success: () => {
            // Resetowanie formularza
            setPassword('');
            setLogin('');
            setFirstName('');
            setLastName('');
            onStudentAdded();
            return 'Kursant został dodany pomyślnie!';
        },
        error: (err) => err.message || 'Wystąpił nieznany błąd.',
    });
    
    try {
        await promise;
    } catch (e) {
        // błąd jest już obsłużony przez toast
    } finally {
        setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ marginTop: '2rem', borderTop: '1px solid #eee', paddingTop: '1rem' }}>
      <h4>Dodaj nowego kursanta</h4>
      <Input id="student-login" label="Login (unikalny)" value={login} onChange={(e) => setLogin(e.target.value)} required />
      <Input id="student-password" label="Hasło tymczasowe" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
      <Input id="student-firstName" label="Imię" value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
      <Input id="student-lastName" label="Nazwisko" value={lastName} onChange={(e) => setLastName(e.target.value)} required />
      <Button type="submit" disabled={isLoading}>
        {isLoading ? 'Dodawanie...' : 'Dodaj kursanta'}
      </Button>
    </form>
  );
};